import script from "./Analysis.vue?vue&type=script&setup=true&lang=js"
export * from "./Analysis.vue?vue&type=script&setup=true&lang=js"

import "./Analysis.vue?vue&type=style&index=0&id=a5ef20ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5ef20ee"]])

export default __exports__